module.exports = "::ng-deep svg {\n  display: block !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/mat-icon-marietti/mat-icon-marietti.component.css
// module id = ./src/app/helpers/mat-icon-marietti/mat-icon-marietti.component.css
// module chunks = main